import React from 'react';
import { useReactiveForm as useReactiveFormShared } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/hooks';
import {
	UseReactiveFormInput,
	UseReactiveFormOutput as UseReactiveFormOutputShared,
	UseReactiveFormInputPropsOutput as UseReactiveFormInputPropsOutputShared,
} from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/$hooks/useReactiveForm/useReactiveForm.types';

interface UseReactiveFormInputPropsOutput
	extends Omit<UseReactiveFormInputPropsOutputShared, 'onChange' | 'showErrors' | 'onFocus' | 'onBlur' | 'error'> {
	status: 'default' | 'error';
	bottomMessage: {
		text: {
			content: string;
		};
	};
	debounce: number;
	onBlur: (blurred: boolean) => void;
	//onBlur: () => void;
	onChangeValue: (value: string) => void;
	onFocus: (focused: boolean) => void;
	//onFocus: () => void;
}

export interface UseReactiveFormOutput extends Omit<UseReactiveFormOutputShared, 'getInputProps'> {
	getInputProps: (name: string) => UseReactiveFormInputPropsOutput;
}

export const useReactiveForm = (props: UseReactiveFormInput): UseReactiveFormOutput => {
	const reactiveForm = useReactiveFormShared(props);
	const inputStatus = React.useRef<Record<string, 'default' | 'focused' | 'blurred'>>({});

	const handleGetInputProps = React.useCallback(
		(name: string): UseReactiveFormInputPropsOutput => {
			const { error, onBlur, onChange, onFocus, value, showErrors } = reactiveForm.getInputProps(name);
			return {
				name,
				status: showErrors && error ? 'error' : 'default',
				onChangeValue: onChange,
				value,
				bottomMessage: {
					text: {
						content: showErrors && error ? error : '',
					},
				},
				debounce: 0,
				onBlur: (): void => {
					onBlur();
				},
				onFocus: (): void => {
					onFocus();
				},
			};
		},
		[reactiveForm]
	);

	return {
		...reactiveForm,
		getInputProps: handleGetInputProps,
	};
};
